<template>
  <section class="section">
    <div class="container" style="padding-top: 20px;">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
          <menu-lateral></menu-lateral>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-9 col-lg-9">
          <div class="row" style="margin-bottom:20px;">
            <div class="col-md-4">
						<ul class="breadcrumbs" style="position:initial;">
						  <li>Administración</li>
						  <li><i class="fa fa-angle-right"></i></li>
						  <li class="active">Liquidaciones</li>
						</ul>
            </div>
            <div class="col-md-8 text-right">
          <div  v-if="sucursales.length>1">
                      <b class="text-brand">Sucursal</b>
                      <div class="btn-group">
                        <button class="btn btn-brand dropdown-toggle" data-toggle="dropdown" id="dd1" aria-expanded="true">
                          {{sucursal.denominacion}}  <i class="fa fa-angle-down"></i>
                        </button>
                        <ul class="dropdown-menu super" aria-labelledby="dd1">
                          <li v-for="suc in sucursales">
                            <a href="" @click.prevent="cambiarSucursal(suc)">{{suc.denominacion}}</a>
                          </li>
                        </ul>
                      </div>
          </div>

            </div>
          </div>


						<div class="box-style line-top">
							<div class="box-header">
								<h2>LIQUIDACIONES</h2>
							</div>
							<div class="box-body">
								<div class="table-header form smart-form">
									<div class="row">
										<div class="col-xs-6 col-sm-6 col-md-4 col-lg-3">
											<div class="form-group">
												<label>Desde</label>
												<date-picker v-model="filtros.desde" :max-date="new Date()"></date-picker>
											</div>
										</div>
										<div class="col-xs-6 col-sm-6 col-md-4 col-lg-3">
											<div class="form-group">
												<label>Hasta</label>
												<date-picker v-model="filtros.hasta" :max-date="new Date()"></date-picker>
											</div>
										</div>
										<div class="col-xs-6 col-sm-6 col-md-4 col-lg-3">
											<label for="">Estado</label>
											<select name="" id="" class="form-control" v-model="filtros.estado">
												<option value="-1">Todos</option>
												<option value="Cerrado">Cerrado</option>
												<option value="Cobrado">Cobrado</option>
												<option value="Parcial">Parcial</option>
											</select>
										</div>	
										<div class="col-xs-12 col-sm-12 col-md-4 col-lg-3">
											<div class="form-group select2-plugin-lg">
												<label>N° LIQUIDACIÓN</label>
												<div class="input-group">
												  <input type="text" class="form-control" v-model="filtros.numero" placeholder="Ingresar número">
												  <span class="input-group-btn">
													<button class="btn btn-default" type="button"><i class="fa fa-search"></i></button>
												  </span>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="clear-xs"></div>
								<div class="table-container">
									<!--
									<div class="form-group">
										<button type="button" class="btn btn-outline btn-sm download-selected" disabled><i class="fa fa-download"></i> DESCARGAR SELECCIONADOS</button>
									</div>
									-->
									<table class="table table-hover table-stripped table-no-first-pad">
										<thead>
											<tr>
												<th></th>
												<th>Liquidación N°</th>
												<th>Fecha</th>
												<th>Monto</th>
												<th>Estado</th>
												<th class="text-right">Acciones</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="liquidacion in liquidacionesFiltradasPaginadas">
												<td>
													<div class="smart-form">
														<label class="checkbox">
															<input type="checkbox" id="download" class="download" name="item1"/>
															<i></i>
														</label>
													</div>
												</td>
												<td>{{liquidacion.numero}}</td>
												<td>{{liquidacion.fechaCreacion | fechaFormateada}}</td>
												<td class="text-right">{{liquidacion.montoTotal | formatMoneda}}</td>
												<td><span class="status-parcial">{{liquidacion.estado}}</span></td>
												<td>
													<ul class="table-actions smart-form">
														<!--
														<li>
															<a href="" class="btn btn-xs btn-ghost" type="button">
																<i class="fa fa-actions fa-download"></i>
															</a>
														</li>
														-->
														<li>
															<router-link :to="'/usuarios/liquidaciones/' + liquidacion._id" class="btn btn-xs btn-ghost" type="button">
																<i class="fa fa-actions fa-eye"></i>
															</router-link>
														</li>
													</ul>
												</td>
											</tr>
										</tbody>
									</table>
									<div class="clear-xs"></div>
									<div class="row">
										<div class="col-xs-12 col-sm-4">
											<!--
											<div class="form-group no-margin">
												<button type="button" class="btn btn-outline btn-sm download-selected" disabled><i class="fa fa-download"></i> DESCARGAR SELECCIONADOS</button>
											</div>
											-->
										</div>
										<div class="col-xs-12 col-sm-4">
											<nav aria-label="Page navigation">
											  <ul class="pagination pagination-sm">
												<li>
												  <a href="#" aria-label="Previous">
													<span aria-hidden="true">&laquo;</span>
												  </a>
												</li>
												<li><a @click.prevent="setCurrentPage(i)" href="#" v-for="i in totalFiltredPages">{{i}}</a></li>
												<li>
												  <a href="#" aria-label="Next">
													<span aria-hidden="true">&raquo;</span>
												  </a>
												</li>
											  </ul>
											</nav>
										</div>
										<div class="col-xs-12 col-sm-4 text-right">
											<span class="size-11">Mostrando de {{pagination.desde + 1}} a {{pagination.hasta}} de un total de {{totalFiltrados}} registros.</span>
										</div>
									</div>
								</div>
							</div>
            </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import MenuLateral from './MenuLateralAdmin'
import DatePicker from '../Shared/DatePicker'
import moment from 'moment'
export default {
  components: {
    'menu-lateral': MenuLateral,
    'date-picker': DatePicker
  },
  computed: {
    liquidacionesFiltradas () {
      const me = this
      let liquidaciones = me.liquidaciones
      if (me.filtros.desde) {
        liquidaciones = liquidaciones.filter((liquidacion) => {
          return new Date(liquidacion.fechaCreacion) >= moment(me.filtros.desde).startOf('day').toDate()
        })
      }
      if (me.filtros.hasta) {
        liquidaciones = liquidaciones.filter((liquidacion) => {
          return new Date(liquidacion.fechaCreacion) < moment(me.filtros.hasta).endOf('day').toDate()
        })
      }
      if (me.filtros.numero) {
        liquidaciones = liquidaciones.filter((liquidacion) => {
          return liquidacion.numero.toString().includes(me.filtros.numero.trim())
        })
      }
      if (me.filtros.estado !== '-1') {
        liquidaciones = liquidaciones.filter((liquidacion) => {
          return liquidacion.estado.toLowerCase().trim() === me.filtros.estado.toLowerCase().trim()
        })
      }
      return liquidaciones
    },
    liquidacionesFiltradasPaginadas () {
      const me = this
      this.pagination.desde = (this.pagination.currentPage - 1) * this.pagination.pageSize
      this.pagination.hasta = this.pagination.desde + this.pagination.pageSize
      let liquidaciones = me.liquidacionesFiltradas.filter((liquidacion, idx) => {
        return idx >= me.pagination.desde && idx < me.pagination.hasta
      })
      this.pagination.hasta = this.pagination.desde + liquidaciones.length
      return liquidaciones
    },
    totalRegistros () {
      return this.liquidaciones.length
    },
    totalFiltrados () {
      return this.liquidacionesFiltradas.length
    },
    totalPages () {
      return Math.ceil(this.totalRegistros / this.pagination.pageSize)
    },
    totalFiltredPages () {
      return Math.ceil(this.totalFiltrados / this.pagination.pageSize)
    }
  },
  data () {
    return {
      filtros: {
        desde: null,
        hasta: null,
        numero: null,
        estado: '-1'
      },
      pagination: {
        currentPage: 1,
        pageSize: 5,
        desde: 0,
        hasta: 0
      },
      liquidaciones: [],
      sucursales: [],
      sucursal: {}
    }
  },
  methods: {
    setCurrentPage (i) {
      this.pagination.currentPage = i
    },
    cambiarSucursal (suc) {
      const me = this
      me.sucursal = suc
      me.cargarLiquidaciones()
    },
    cargarLiquidaciones (suc) {
      const me = this
      me.$http.get('/api/users/liquidaciones', {params: {sucursal: me.sucursal._id}}).then(({body}) => {
        me.liquidaciones = body.liquidaciones
      }, (err) => {
        console.error(err)
      })
    }
  },
  filters: {
    fechaFormateada (value) {
      return moment(new Date(value)).format('DD/MM/YYYY HH:mm')
    },
    formatMoneda (value) {
      return '$ ' + parseFloat(value).toFixed(2)
    }
  },
  mounted () {
    const me = this
    me.$http.get('/api/users/inithistorialempresa').then(({body}) => {
      const data = body
      me.sucursales = data[0]
      me.sucursal = me.sucursales[0]
      me.cargarLiquidaciones()
    }, (err) => {
      console.log(err)
    })
  }
}
</script>



// WEBPACK FOOTER //
// Liquidaciones.vue?00c6dd9b